import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RouterModule } from '@angular/router';
import { TranslationLoaderService } from '../../services/translationLoader.service';
import { MatTableModule, MatSortModule, MatPaginatorModule } from '@angular/material';
import { ChatbotWidgetComponent } from './chatbot-widget/chatbot-widget.component';
import { ChatbotWorkspaceComponent } from './chatbot-workspace/chatbot-workspace.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    NgbDropdownModule,
    NgbAlertModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [HeaderComponent, FooterComponent, ChatbotWidgetComponent, ChatbotWorkspaceComponent],
  exports: [HeaderComponent, FooterComponent, ChatbotWidgetComponent, ChatbotWorkspaceComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [TranslationLoaderService]
})
export class SharedModule { }
